import { IonAlert } from "@ionic/react";

const OverworkBookingAlert = ({ isOpen, onDidDismiss }) => {
  return (
    <IonAlert
      isOpen={isOpen}
      onDidDismiss={onDidDismiss}
      cssClass="shift-item-alert"
      // FIXME: Don't inject HTML as a string here
      message={`
        <h1>Oops, you can't book this shift!</h1>
        <p>Consistent with our Terms of Service, you may not book back-to-back shifts resulting in
        over 17 hours worked in a row. Your other booked shift(s), combined with this shift,
        would exceed that limit.</p>
        <p>We are doing this to help make sure our marketplace's users have a positive experience.
        </p>
      `}
      buttons={[
        {
          text: "Ok",
          role: "confirm",
          handler: onDidDismiss,
        },
      ]}
    />
  );
};

export { OverworkBookingAlert };
